import type { TargetTypeType } from '@terra/shared-schemas-orchestrator';
import { resolveHistoryTarget } from '../hooks/useHistoryDatasource';
import { useProjectStore } from '../store/projectStore';
import { useProxyStore } from '../store/proxy-store';

export const getCurrentHistoryTarget = (): {
  targetId: string;
  targetType: TargetTypeType;
} => {
  const { targetId: projectTargetId, targetType: projectTargetType } =
    useProjectStore.getState();
  const { currentTargetId, currentTargetType } = useProxyStore.getState();

  return resolveHistoryTarget({
    applicationIdProp: projectTargetId || undefined,
    projectTargetId,
    projectTargetType,
    storeTargetId: currentTargetId,
    storeTargetType: currentTargetType,
  });
};
